module.exports = __webpack_public_path__ + "static/img/zbjb.408edd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/zbjb.png
// module id = KJVU
// module chunks = 1